import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  viewChild
} from '@angular/core';
import {CommonModule, isPlatformBrowser, ViewportScroller} from '@angular/common';
import {WordpressService} from "../../../services/wordpress.service";
import {ActivatedRoute, EventType, NavigationExtras, NavigationStart, Router, Scroll} from "@angular/router";
import {SEOService} from "../../../services/seo.service";
import {PageExtended} from "../../../models/Page/PageExtended";
import {TextImagesSectionComponent} from "../../modules/text-images-section/text-images-section.component";
import {SwiperComponent, SwiperModule} from "swiper/angular";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {BreacrumbsComponent} from "../../elements/breacrumbs/breacrumbs.component";
import {ListPagesSectionComponent} from "../../modules/list-pages-section/list-pages-section.component";
import {WP_PAGE_ACF_FC_Layouts} from "../../../enums/wp-page-acf-fc-layouts";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {SelectionSitSectionComponent} from "../../modules/selection-sit-section/selection-sit-section.component";
import {PageNavigationComponent} from "../../elements/page-navigation/page-navigation.component";
import {ListLinksSectionComponent} from "../../modules/list-links-section/list-links-section.component";
import {InstagramItemComponent} from "../../elements/instagram-item/instagram-item.component";
import {BookmarksSectionComponent} from "../../modules/bookmarks-section/bookmarks-section.component";
import {ThemeService} from "../../../services/theme.service";
import {CurrentlySectionComponent} from "../../modules/currently-section/currently-section.component";
import {ContextSectionComponent} from "../../modules/context-section/context-section.component";
import {FreeSectionComponent} from "../../modules/free-section/free-section.component";
import {NewsletterSectionComponent} from "../../modules/newsletter-section/newsletter-section.component";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Lazy,
  Navigation,
  SwiperOptions
} from "swiper";
import {filter} from "rxjs";
import {EvenementSitSectionComponent} from "../../modules/evenement-sit-section/evenement-sit-section.component";
import {ItineraireSectionComponent} from "../../modules/itineraire-section/itineraire-section.component";
import {AnalyticsService} from "../../../services/analytics.service";
import {RedirectionService} from "../../../services/redirection.service";
SwiperCore.use([Autoplay,EffectFade,Lazy,Navigation]);
@Component({
  selector: 'page',
  standalone: true,
  imports: [CommonModule, TextImagesSectionComponent, SwiperModule, AttachmentFromIdPipe, MediaAttachmentComponent, BreacrumbsComponent, ListPagesSectionComponent, SelectionSitSectionComponent, PageNavigationComponent, ListLinksSectionComponent, InstagramItemComponent, BookmarksSectionComponent, CurrentlySectionComponent, ContextSectionComponent, FreeSectionComponent, NewsletterSectionComponent, EvenementSitSectionComponent, ItineraireSectionComponent],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
})
export class PageComponent implements OnInit{
  page?: PageExtended;
  template : 'home'|'page' = 'page'
  hasDefaultNewsletterSection= false;
  @ViewChild("slider") slider:SwiperComponent;
  sliderConfig : SwiperOptions = {
    loop: true,
    modules: [Autoplay, EffectFade, Lazy,Navigation],
    effect: 'fade',
    lazy: {loadOnTransitionStart:true},
    speed: 2000,
    autoplay : {
      delay : 4000,
      pauseOnMouseEnter : false,
      disableOnInteraction: false
    },
    pagination: {clickable: true},
    navigation: false,
    slidesPerView : 1,
    on: {
      slideChange: () => {
        this.setSliderAutoplay();
      }
    }
  }
  @ViewChild('carrousel') carrouselRef? : SwiperComponent
  constructor(
    public wordpress : WordpressService,
    public route: ActivatedRoute,
    public seo : SEOService,
    private themeService: ThemeService,
    private analyticsService: AnalyticsService,
    private redirection: RedirectionService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.themeService.template$.subscribe((data)=>{
      this.template = data;
    });
  }
  ngOnInit() {
    this.route.paramMap.subscribe(async (params) => {
      const slugs = [];
      for (let i = 0; i < 6; i++) {
        if (params.get("slug" + i)) {
          slugs.push(params.get("slug" + i));
        }
      }
      const slug = slugs[slugs.length - 1];
      const link = "/"+slugs.join('/');
      if (slug) {
        this.themeService.setCurrentTemplate('page');
        await this.wordpress.getPageBySlug(slug,link).then((page) => this.initPage(page)).catch((e) => {
          this.redirection.redirect(link).catch((e)=>{
            this.router.navigate(['/404'],{skipLocationChange:true,state: {error: 404}});
            this.redirection.setNotFound();
          })

        });
      } else {
        this.themeService.setCurrentTemplate('home')
        this.themeService.setLanguageList('home');
        await this.wordpress.getFrontpage().then((page) => this.initPage(page)).catch((e) => {
          this.router.navigate(['/404'],{skipLocationChange:true,state: {error: 404}});
          this.redirection.setNotFound();
        });
      }
    });
  }

  setSliderAutoplay(){
    if(this.slider){
      // Pause autoplay when the slide changes
      this.slider.swiperRef.autoplay.stop();
      // Find the currently active slide index
      const activeIndex = this.slider.swiperRef.realIndex;
      // Check if the active slide is a video slide
      const activeSlide = this.page?.acf.carrousel[activeIndex];
      if (activeSlide?.video) {
        // If it's a video slide, wait for the video to end before resuming autoplay
        const videoElement = document.querySelector('.swiper-slide-active video') as HTMLVideoElement;
        if (videoElement) {
          videoElement.onended = () => {
            this.slider.swiperRef.autoplay.start();
          };
        }
      } else {
        // If it's not a video slide, resume autoplay immediately
        this.slider.swiperRef.autoplay.start();
      }
    }
  }

  initPage(page: PageExtended|null){
    if(page){
      this.page = page;
      if(page.slug !== '404' && page.slug !== '/404' && this.page.title.rendered !== '404'){
        this.analyticsService.trackPageView(this.router.url, this.page.title.rendered);
      }
      this.themeService.setLanguageList('page',this.page.id).then(()=>{
        this.seo.initHrefLangs(this.themeService.languages??[],this.themeService.lang.current);
      });
      this.initMetas();
      this.initHasDefaultNewsletterSection();
      this.setSliderAutoplay();
    }
  }

  initMetas(){
    if(this.page?.yoast_head_json) {
      this.seo.setCanonical(this.page.yoast_head_json.canonical);
      this.seo.setTitles(this.page.yoast_head_json.title);
      this.seo.setDescriptions(this.page.yoast_head_json.description);
      if(this.page.yoast_head_json.og_image?.length>0){
        const og_image = this.page.yoast_head_json.og_image[0];
        this.seo.setOgImage(og_image.url);
        this.seo.setOgImageHeight(og_image.height);
        this.seo.setOgImageWidth(og_image.width);
        this.seo.setOgImageType(og_image.type);
      }
      this.seo.setOgUrl(this.page.yoast_head_json.og_url);
      this.seo.setOgType(this.page.yoast_head_json.og_type);
      this.seo.setOgLocale(this.page.yoast_head_json.og_locale);
      if(this.page.featured_media_object){
        this.seo.setTwitterImage(this.page.featured_media_object.source_url);
      }
      this.seo.setRobots(this.page.yoast_head_json.robots.index,this.page.yoast_head_json.robots.follow);
    }
  }



  initHasDefaultNewsletterSection(){
    if(!this.page?.acf?.sections?.find((s)=>s.acf_fc_layout == WP_PAGE_ACF_FC_Layouts.NEWSLETTER) && this.page?.children?.length){
      this.hasDefaultNewsletterSection = true
    }
  }

  protected readonly WP_PAGE_ACF_FC_Layouts = WP_PAGE_ACF_FC_Layouts;
}
